import { Grid, Toolbar } from "@mui/material";
import React, { useEffect, useState } from "react";
import Sidebar from "../../../components/Qna/Sidebar";
import { Link } from "react-router-dom";
import FilterListIcon from "@material-ui/icons/FilterList";
import { Avatar, Typography, Chip, Box } from "@mui/material";
import axios from "axios";

function UserHome() {
  const [questions, setQuestions] = useState([]);
  const [uniqueUsers, setUniqueUsers] = useState([]);
  useEffect(() => {
    async function getQuestion() {
      try {
        const res = await axios.get("/api/question", {
          baseURL: process.env.REACT_APP_FORUM_API,
        });
        const data = res.data.reverse();
        setQuestions(data);
  
        // Get unique users, ensuring that userName is valid
        const users = data
          .map((question) => question.user)
          .filter((user) => user.userName); // Only include valid users
  
        // Get unique users based on userName
        const unique = Array.from(
          new Map(users.map((user) => [user.userName, user])).values()
        );
  
        setUniqueUsers(unique);
        console.log(unique); // Debug here to check unique users
      } catch (error) {
        console.error("Error fetching questions:", error);
      }
    }
    getQuestion();
  }, []);
  

  const getTopTags = (userName) => {
    // Filter the questions by the current user
    const userQuestions = questions.filter(
      (question) => question.user.userName === userName
    );

    // Create a map to count the frequency of each tag
    const tagCount = {};

    // Loop through the questions and tags to count them
    userQuestions.forEach((question) => {
      question.tagDetails.forEach((tag) => {
        const tagName = tag.name; // Assuming tagDetails has 'name' for the tag
        tagCount[tagName] = (tagCount[tagName] || 0) + 1;
      });
    });

    // Sort tags by count and return the top 3 tags
    const sortedTags = Object.entries(tagCount)
      .sort((a, b) => b[1] - a[1]) // Sort by frequency (descending)
      .slice(0, 3); // Get top 3

    return sortedTags.map((tag) => tag[0]); // Return just the tag names
  };
  

  return (
    <Grid container>
      <Grid item container xs={12}>
        <Grid
          item
          xs={2}
          sx={{
            position: "sticky",
            top: 0,
            alignSelf: "flex-start",
            height: "100vh",
            overflowY: "auto",
          }}
        >
          <Toolbar style={{ minHeight: "30px" }} sx={{ height: "0.5rem" }} />
          <Sidebar />
        </Grid>

        <Grid item xs={10}>
          <div className="main">
            <div className="main-container">
              <div className="main-top">
                <h2>Users</h2>
              </div>
              <div className="main-desc">
                <h6 className="question length"></h6>
                <div className="main-filter">
                  <div
                    className="main-tabs"
                    style={{ display: "flex", justifyContent: "space-around" }}
                  >
                    <div
                      className="main-tab"
                      style={{
                        width: "auto",
                        height: "auto",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: "#ffff",
                        borderRadius: "4px",
                      }}
                    >
                      <Link to="">Reputation</Link>
                    </div>
                    <div
                      className="main-tab"
                      style={{
                        width: "auto",
                        height: "auto",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: "#ffff",
                        borderRadius: "4px",
                      }}
                    >
                      <Link to="">Newusers</Link>
                    </div>
                    <div
                      className="main-tab"
                      style={{
                        width: "auto",
                        height: "auto",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: "#ffff",
                        borderRadius: "4px",
                      }}
                    >
                      <Link to="">Voters</Link>
                    </div>
                    <div
                      className="main-tab"
                      style={{
                        width: "auto",
                        height: "auto",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: "#ffff",
                        borderRadius: "4px",
                      }}
                    >
                      <Link to="">Editors</Link>
                    </div>
                    <div
                      className="main-tab"
                      style={{
                        width: "auto",
                        height: "auto",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: "#ffff",
                        borderRadius: "4px",
                      }}
                    >
                      <Link to="">Moderators</Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="container">
            <div className="row">
              {uniqueUsers.map((user, index) => (
                 console.log(uniqueUsers),
                <div className="col-md-3 col-sm-6 col-12" key={index}>
                  {/* <Link to={`/userdetails/${user?.userName || "guest"}`}> */}
                    <Box
                      display="flex"
                      flexDirection="column"
                      alignItems="center"
                      p={0.5}
                      border={1}
                      borderRadius={1}
                      width={230}
                      sx={{
                        maxWidth: 230,
                        margin: "auto",
                        marginBottom: "1rem",
                      }}
                    >
                      {/* Avatar and Name Section */}
                      <Avatar
                        sx={{
                          width: 40,
                          height: 40,
                          mb: 0.5,
                          bgcolor: "#3f51b5", // Background color for the avatar
                          color: "#fff", // Text color
                          fontSize: "1rem",
                        }}
                      >
                        {user.userName?.charAt(0).toUpperCase()}
                      </Avatar>

                      <Typography
                        variant="p1"
                        fontSize="0.83rem"
                        fontWeight="bold"
                        sx={{ color: "#808080" }}
                      >
                        {user.userName}
                      </Typography>

                      {/* Example Placeholder Data */}
                      <Typography
                        variant="body2"
                        color="textSecondary"
                        fontSize="0.75rem"
                      >
                        United State
                      </Typography>
                      <Typography
                        variant="body2"
                        color="textSecondary"
                        fontSize="0.75rem"
                        mt={0.5}
                      >
                        215 Followers
                      </Typography>
                      <Box mt={0.5}>
                        {getTopTags(user.userName).map((tag, index) => (
                          <Chip
                            key={index}
                            label={tag}
                            size="small"
                            sx={{ marginRight: 0.5, fontSize: "0.6rem" }}
                          />
                        ))}
                      </Box>
                    </Box>
                  {/* </Link> */}
                </div>
              ))}
            </div>
          </div>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default UserHome;
